import { athleteSettingsApi, type CloudIntegrationProvider } from '../services/athleteSettingsApi';
import { isCloudIntegrationProvider } from './cloudIntegrationOAuth';

const KEY = 'vo2_cloud_oauth_return';
export function readCloudReturnAthlete(provider: CloudIntegrationProvider): number | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) ?? 'null');
    return value?.provider === provider && Number.isSafeInteger(value.athleteId) && value.athleteId > 0
      ? value.athleteId : null;
  } catch { return null; }
}
export function clearCloudReturn(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* storage unavailable */ }
}
export function parseCloudRedirectResult(params: URLSearchParams) {
  const provider = params.get('provider');
  const status = params.get('status');
  if (!isCloudIntegrationProvider(provider) || (status !== 'success' && status !== 'error')) return null;
  return { provider, success: status === 'success', message: params.get('message') ?? '' };
}
export async function redirectToCloudIntegration(provider: CloudIntegrationProvider, athleteId: number): Promise<void> {
  const response = await athleteSettingsApi.getCloudIntegrationAuthUrl(provider, athleteId);
  const url = response.data.data?.auth_url;
  if (typeof url !== 'string' || !url.trim()) throw new Error(`${provider} auth URL missing`);
  const destination = new URL(url);
  if (destination.protocol !== 'https:' && destination.protocol !== 'http:') throw new Error('Invalid authorization URL');
  try { sessionStorage.setItem(KEY, JSON.stringify({ provider, athleteId })); } catch { /* storage unavailable */ }
  window.location.assign(destination.href);
}
